const CardGrid = ({ children }) => (
    <div className="cardGrid">
      {children}
    </div>
  )
  
  export default CardGrid